import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TextVariableService {
    getVariables(text) {
        const matches = text.match(/{{(\S)*?}}/g);
        return matches ? [...new Set(matches)] : [];
    }
}
